import React, { memo, useRef } from "react";
import { Form, Formik } from "formik";
import {
  createLogEntryPayload,
  withTrackProps,
} from "@dpdgroupuk/react-event-tracker";

import SimpleModal from "../../components/SimpleModal";
import { PARCEL_SEARCH } from "../../constants/strings";
import { validateParcelSearch } from "./validators";
import ParcelSearchForm from "./components/ParcelSearchForm";
import useSearchParcel from "../../hooks/useSearchParcel";
import { PARCEL_SEARCH_MODAL } from "../../constants/analytics";

const ParcelSearch = ({
  open,
  onClose,
  onReset,
  onSearch,
  onFinish,
  onEnter,
}) => {
  const parcelNumberRef = useRef();
  const [foundParcels, handleReset, handleSearch] = useSearchParcel();

  const handleResetClick = () => {
    handleReset();
    onReset();
  };

  const handleSearchClick = (data) => {
    handleSearch(data);
    onSearch();
  };

  const handleFinishClick = () => {
    onFinish();
    onClose();
  };

  const handleEnterParcelcNumber = (data) => {
    onEnter(data.parcelNumber);
    return validateParcelSearch(data);
  };

  return (
    <SimpleModal
      onClose={onClose}
      open={open}
      title={PARCEL_SEARCH.toUpperCase()}
      loadId={PARCEL_SEARCH_MODAL.LOAD}
    >
      <Formik
        enableReinitialize
        onSubmit={handleSearchClick}
        initialValues={{ parcelNumber: "" }}
        validate={handleEnterParcelcNumber}
        validateOnChange={false}
        onReset={handleResetClick}
      >
        {({ values, handleSubmit, errors, resetForm }) => (
          <Form style={{ width: "100%" }}>
            <ParcelSearchForm
              values={values}
              handleReset={resetForm}
              handleFinish={handleFinishClick}
              handleSearch={handleSubmit}
              parcelNumberRef={parcelNumberRef}
              foundParcels={foundParcels}
              errors={errors}
            />
          </Form>
        )}
      </Formik>
    </SimpleModal>
  );
};

export default withTrackProps({
  onClose: PARCEL_SEARCH_MODAL.CLICK_CLOSE,
  onReset: PARCEL_SEARCH_MODAL.CLICK_RESET,
  onSearch: PARCEL_SEARCH_MODAL.CLICK_SEARCH,
  onFinish: PARCEL_SEARCH_MODAL.CLICK_FINISHED,
  onEnter: (value) =>
    createLogEntryPayload(PARCEL_SEARCH_MODAL.ENTER_PARCEL_NUMBER, { value }),
})(memo(ParcelSearch));
